export default __webpack_public_path__ + "static/media/benefit_11.abf85385.png";